import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TAuthSliceState = {
  test: any;
};

const initialState: TAuthSliceState = {
  test: null,
};

const testSlice = createSlice({
  name: 'testSlice',
  initialState,
  reducers: {
    setTest(state, action: PayloadAction<any>) {
      state.test = action.payload;
    },
  },
});

export default testSlice;
